import { useEffect, useState } from "react";

//Common
import {
  IDENTIFICACAO_USUARIO_SYSTEM,
  SISTEMA_SIGLA,
} from "../../common/constantes";

//Util
import { fn_ambienteIsProducao, fn_getDescricaoAmbiente } from "../utils/env";
import { fn_getPathTenant, fn_getUsuario } from "../utils/sessao";

function Footer({ sessaoUsuario }) {
  //### USE STATE ###
  const [usuario, setUsuario] = useState(null);
  const [pathTenant, setPathTenant] = useState(null);

  //### USE EFFECT ###
  useEffect(() => {
    setPathTenant(fn_getPathTenant(sessaoUsuario));
    setUsuario(fn_getUsuario(sessaoUsuario));
  }, []);

  return (
    <div className="footer">
      <div className="footer-content">
        <>
          <p>
            {SISTEMA_SIGLA} {__APP_VERSION__}
          </p>
          <p>{"Usuário: " + (usuario ? usuario.nome.toUpperCase() : "")}</p>

          <p>
            {"Perfil: " +
              (usuario?.perfil ? usuario.perfil.nome.toUpperCase() : "")}
          </p>

          <div className="footer-content-end">
            {pathTenant ? (
              <div className="d-flex align-itemms-center">
                {!fn_ambienteIsProducao() && (
                  <span className="me-3 fw-bold bg-light text-danger">
                    {fn_getDescricaoAmbiente()}
                  </span>
                )}

                <span
                  className={`me-3 ${pathTenant.toUpperCase() == "DEMONSTRACAO" ? "fw-bold bg-light text-danger" : ""}`}
                >
                  {pathTenant.toUpperCase()}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      </div>
    </div>
  );
}
export default Footer;
